import { memo, useContext } from 'react';
import { UserContext } from 'contexts';
import Loader from 'components/Shared/Loader';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';

const ProtectedRoute = memo(({ ...rest }) => {
  const { user, isLogin, metadata } = useSelector((state) => state.user);
  const { changeAccountLoading } = useContext(UserContext);
  const { settings } = useSelector((state) => state.table);
  const {
    additional: { component: Component },
  } = rest;
  if (
    changeAccountLoading ||
    isLogin === undefined ||
    (isLogin && user === null) ||
    (isLogin && user === undefined) ||
    (isLogin && user && metadata === null) ||
    (isLogin && user && metadata === undefined)
  ) {
    return <Loader fullHeight />;
  }

  // Redirect to login if user is not logged in
  if (isLogin === false) {
    return <Navigate to="/login" replace />;
  }

  if (rest.skipDashboardCommonLayout) {
    return <Component {...rest} />;
  }

  return <Dashboard>
    <div style={{
      width: '100%',
      height: '100%',
      backgroundColor: 'white',
      position: 'relative',
    }}>
      {settings ? <Component {...rest} /> :
        <div style={{ height: '100%', width: '100%', backgroundColor: '#ffffff' }}>
          <Loader fullHeight />
        </div>}
    </div>
  </Dashboard>;
});

ProtectedRoute.propTypes = {};

export default ProtectedRoute;
